module.exports = __webpack_public_path__ + "static/media/cover.fde762c2.jpg";